// extracted by mini-css-extract-plugin
export default {"wrapper":"HE-z","button":"IE-z","alternate":"JE-z","disabled":"KE-z","paymentWarning":"LE-z","fadeIn":"ME-z"};